import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { isFactorRequiredCategory } from "./const";

/**
 * Sub-grid shown when a Certified Renewable, Supplier Contracted or
 * Direct / Private Wire purchased-electricity row is expanded. Surfaces the
 * calculation details that don't fit in the main row (Type / Emission factor /
 * Supplier note). `row` is the API record (emissionFactor / certificateType /
 * supplierNote at top level).
 */
function RowDetails({ row }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope2V2",
  });

  if (row.category === "CERTIFIED_RENEWABLE") {
    const typeLabel = row.certificateType ? t(`renewableTypes.${row.certificateType}`) : "";
    const factor =
      row.emissionFactor !== "" && row.emissionFactor !== null && row.emissionFactor !== undefined
        ? row.emissionFactor
        : "0";
    return (
      <Flex gap={10} flexWrap="wrap">
        <Box>
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" letterSpacing="0.04em" mb={1}>
            {t("columns.type")}
          </Text>
          <Text fontSize="14px" color={typeLabel ? "gray.700" : "red.500"}>
            {typeLabel || t("required")}
          </Text>
        </Box>
        <Box>
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" letterSpacing="0.04em" mb={1}>
            {t("columns.emissionFactor")}
          </Text>
          <Text fontSize="14px" color="gray.700">{factor}</Text>
        </Box>
      </Flex>
    );
  }

  if (isFactorRequiredCategory(row.category)) {
    const factor = row.emissionFactor;
    const hasFactor = factor !== "" && factor !== null && factor !== undefined;
    const note = row.supplierNote;
    const hasNote = !!note && `${note}`.trim().length > 0;
    return (
      <Flex gap={10} flexWrap="wrap" align="flex-start">
        <Box minW="120px">
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" letterSpacing="0.04em" mb={1}>
            {t("columns.emissionFactor")}
          </Text>
          <Text fontSize="14px" color={hasFactor ? "gray.700" : "red.500"}>
            {hasFactor ? factor : t("required")}
          </Text>
        </Box>
        <Box flex="1" minW="240px">
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" letterSpacing="0.04em" mb={1}>
            {t("columns.supplierNote")}
          </Text>
          <Text fontSize="14px" color={hasNote ? "gray.700" : "gray.400"}>
            {hasNote ? note : "—"}
          </Text>
        </Box>
      </Flex>
    );
  }

  return null;
}

export default RowDetails;
